import React from 'react';

/**
 * Unified Card Component
 * Container for content sections
 */
const Card = ({ 
  children, 
  title = '', 
  subtitle = '',
  className = '',
  padding = 'default', // none, sm, default, lg
  hover = false
}) => {
  const paddingStyles = {
    none: '',
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8'
  };
  
  const hoverStyles = hover ? 'hover:shadow-xl hover:shadow-primary-500/10 hover:border-primary-500/50 transition-all duration-300' : '';
  
  return (
    <div className={`bg-slate-800 border border-slate-700 rounded-xl shadow-lg ${paddingStyles[padding]} ${hoverStyles} ${className}`}>
      {(title || subtitle) && (
        <div className="mb-4">
          {title && (
            <h3 className="text-xl font-semibold text-slate-100 mb-1">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="text-sm text-slate-400">
              {subtitle}
            </p>
          )}
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
